(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AccountCard", [], factory);
	else if(typeof exports === 'object')
		exports["AccountCard"] = factory();
	else
		root["AccountCard"] = factory();
})(this, function() {
return 